import axios, { type AxiosResponse } from 'axios'

export const apiGet = async (
  apiPath: string,
  id: string,
  queryParams?: any
): Promise<any> => {
  const params = queryParams ? { params: queryParams } : {}
  const response: AxiosResponse<any> = await axios.get(
    `${apiPath}/${id}`,
    params
  )
  return response.data
}

export async function apiList<T>(
  apiPath: string,
  queryParams?: any
): Promise<T> {
  const params = queryParams ? { params: queryParams } : {}
  const response: AxiosResponse<any> = await axios.get(apiPath, params)
  return response.data
}

export const apiPost = async (apiPath: string, body: any): Promise<any> => {
  const response: AxiosResponse<any> = await axios.post(apiPath, body)
  return response.data
}

export const apiPatch = async (apiPath: string, body: any): Promise<any> => {
  const response: AxiosResponse<any> = await axios.patch(apiPath, body)
  return response.data
}

export const apiPut = async (
  apiPath: string,
  id: string,
  body: any
): Promise<any> => {
  const response: AxiosResponse<any> = await axios.put(`${apiPath}/${id}`, body)
  return response.data
}

export const apiDelete = async (apiPath: string, id: string): Promise<any> => {
  const response: AxiosResponse<any> = await axios.delete(`${apiPath}/${id}`)
  return response.data
}

export const apiBasicLogin = async (
  apiPath: string,
  username: string,
  password: string
): Promise<any> => {
  return (await axios.post(apiPath, {}, { auth: { username, password } })).data
}
